import { siteDevelopmentUrl } from "../../utility/Index";

export const usingTokensBeltsCoinsData = {
  UsingTokensBeltsCoins: {
    Title: "Using Tokens, Belts & Coins",
    GeneralTopData: [],
    GeneralBottomData: [],
    Steps: [
      {
        StepTitle: "What Are Tokens?",
        Description: [
          "Currency on the Platform: Tokens are the virtual currency used on our platform. You can purchase tokens with real money and use them to access various features.",
        ],
      },
      {
        StepTitle: "Purchasing Tokens",
        "Description": [
          `How to Buy: Go to the “<a href='${siteDevelopmentUrl}/Purchase'>Buy Tokens</a>” section in your profile. Select the amount of tokens you want to purchase, and complete the transaction using your preferred payment method.`,
        ]
      },
      {
        StepTitle: "What Are Belts?",
        Description: [
          "Challenging Currency: Belts are used to challenge other players on the platform. You can only purchase a Bronze Belt with tokens, and winning challenges allows you to progress to Silver, Gold, and Platinum Belts.",
        ],
      },
      {
        StepTitle: "Using Tokens To Buy Belts",
        Description: [
          `<a href='${siteDevelopmentUrl}/Profile'>Purchase Belts</a>: Use your tokens to buy Bronze Belts. Navigate to the 'Belts' section in your profile, select the number of belts you want to purchase, and confirm the transaction.`,
        ],
      },
      {
        StepTitle: "Challenging Opponents With Belts",
        Description: [
          "Initiate Challenges: Once you have belts, you can challenge other players by selecting a game and setting the number of belts as the wager. The winner takes the belts after the challenge is completed.",
        ],
      },
      {
        StepTitle: "Redeeming Belts",
        Description: [
          "Convert Belts to Credits: Once you have earned Silver, Gold, or Platinum Belts, you can convert them back into credits with a corresponding currency value. This can be done in the 'Belts' section of your profile.",
        ],
      },
      {
        StepTitle: "Using Tokens for Gifts",
        Description: [
          "Support Streamers: Tokens can also be used to purchase gifts, which you can send to your favourite streamers during live events. Simply select the gift you want to send and confirm the token expenditure.",
        ],
      },
      {
        StepTitle: "Coins: Understanding and Using Them on the Platform",
        Description: [],
      },
    ],
  },
};

export const usingCoinsData = {
  Coins: {
    GeneralTopData: ["Coins: Understanding and Using Them on the Platform"],
    GeneralBottomData: [""],
    Steps: [
      {
        StepTitle: "What Are Coins?",
        Description: [
          "Free Currency: Coins are a type of virtual currency that users receive for free on a monthly basis. They allow you to participate in challenges and events without needing to purchase tokens.",
        ],
      },
      {
        StepTitle: "How to Earn Coins",
        Description: [
          "Monthly Allotment: Every user receives a set amount of coins each month. These coins are automatically added to your account.",
        ],
      },
      {
        StepTitle: "Using Coins in Challenges",
        Description: [
          "Wagering Coins: Coins can be used in place of tokens when creating or accepting challenges.",
          "Ranking Up: Use coins strategically to participate in challenges and increase your ranking on the platform.",
        ],
      },
      {
        StepTitle: "Managing Coins",
        Description: [
          "Tracking Coins: View your current coin balance in your profile. Keep track of how many coins you have left for the month and plan your challenges accordingly.",
        ],
      },
      {
        StepTitle: "Limitations of Coins",
        Description: [
          "No Conversion: Unlike tokens, coins cannot be converted into belts, gifts, or real money. They are exclusively for participating in challenges and demonstrating ability and skills.",
        ],
      },
    ],
  },
};
